import "../toast.css";

const LoanToastContent = ({ title, fullName, message, image, toastType }) => {
  const getIcon = () => {
    switch (toastType) {
      case "success":
        return "✓";
      case "error":
        return "✕";
      case "warning":
        return "!";
      case "info":
        return "ℹ";
      default:
        return "!";
    }
  };

  return (
    <div className="toast-content">
      {image && (
        <div className="toast-image">
          <img src={image} alt={fullName} />
        </div>
      )}
      <div className="toast-text">
        <div className="toast-title-row">
          <span className="toast-title">{title}</span>
          <span className={`toast-icon toast-icon-${toastType}`}>
            {getIcon()}
          </span>
        </div>
        <h2 className="toast-name">{fullName}</h2>
        <p className="toast-message">{message}</p>
      </div>
    </div>
  );
};

export default LoanToastContent;
